import React from 'react';
import { Bars3Icon } from '@heroicons/react/24/outline';

interface NavbarProps {
    toggleSidebar: () => void;
    isCollapsed: boolean;
}

const Navbar: React.FC<NavbarProps> = ({ toggleSidebar, isCollapsed }) => {
  return (
    <div className={`fixed top-0 right-0 left-0 z-40 transition-all duration-300 ${isCollapsed ? 'lg:left-20' : 'lg:left-48'}`}>
      <div className="w-full h-1 bg-accent-blue" />
      <nav className="bg-slate-900 w-full" style={{ borderBottomWidth: 0 }}>
        <div className="mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between h-16 items-center">
            <div className="flex items-center lg:hidden">
                <button
                    type="button"
                    className="-m-2.5 p-2.5 text-gray-400"
                    onClick={toggleSidebar}
                >
                    <span className="sr-only">Open sidebar</span>
                    <Bars3Icon className="h-6 w-6" aria-hidden="true" />
                </button>
            </div>
            <div className="hidden lg:flex lg:flex-1"></div>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default Navbar;
